import { Role } from "domain/entities/role";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface RolesListState {
  roles: Role[];
  setRoles: (newRoles: Role[] | undefined) => void;
}

export const useRolesStore = create<RolesListState>()(
  devtools(
    (set) => ({
      roles: [],
      setRoles: (newRoles) =>
        set(() => ({
          roles: newRoles ? [...newRoles] : [],
        })),
    }),
    { name: "RolesStore" }
  )
);
